"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/actions.ts
 ** module id = 97
 ** module chunks = 1
 **/